// extracted by mini-css-extract-plugin
export default {"tableHeader":"DiscountByStylist_tableHeader__gVHGA","buttonFont":"DiscountByStylist_buttonFont__GZP9g"};